// extracted by mini-css-extract-plugin
export default {"container":"ResponseError_container__h4B5U","text":"ResponseError_text__IKMQ0","icon":"ResponseError_icon__m7hle"};